function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgApikey(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M91.16 83.879l-28.318-40.61a27.123 27.123 0 002.613-11.625C65.455 16.677 53.278 4.5 38.311 4.5c-14.967 0-27.144 12.177-27.144 27.144s12.177 27.144 27.144 27.144c1.018 0 2.049-.06 3.081-.179l2.967 1.79 2.949 10.865a4.002 4.002 0 002.303 2.637l8.933 3.776 6.508 10.584a4 4 0 003.407 1.905H87.88a4 4 0 003.28-6.287zm-20.466-1.712l-6.007-9.77a3.996 3.996 0 00-1.85-1.59l-8.319-3.517-2.86-10.536a3.996 3.996 0 00-1.794-2.377l-5.561-3.354a3.978 3.978 0 00-2.741-.518 19.3 19.3 0 01-3.252.281c-10.556 0-19.144-8.588-19.144-19.144S27.754 12.5 38.311 12.5s19.145 8.588 19.145 19.144c0 3.475-.941 6.878-2.724 9.843a4.002 4.002 0 00.147 4.349l25.334 36.332h-9.519z"
  }), React.createElement("circle", {
    cx: 38.076,
    cy: 31.833,
    r: 7.551
  }));
}

SvgApikey.clsName = 'icon-www__apikey';
SvgApikey.remarkName = 'unknown';
export default SvgApikey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Apikey.js
// module id = 2275
// module chunks = 17 18